export const VIEW_ACCOUNT = 'View Account';
